import { AnimatePresence, motion } from 'framer-motion';
import { memo } from 'react';
import { Attachment } from './Attachment.client';
import type { FileAttachment } from '~/types/chat';

interface FileAttachmentsProps {
  className?: string;
  attachments?: FileAttachment[];
  onRemoveAttachment?: (attachment: FileAttachment) => void;
}

export const FileAttachments = memo(({ className, attachments = [], onRemoveAttachment }: FileAttachmentsProps) => {
  return (
    <div className={className}>
      <AnimatePresence>
        {attachments.map((attachment) => {
          return (
            <motion.div
              key={attachment.id}
              layoutId={attachment.id}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15 }}
            >
              <Attachment attachment={attachment} allowRemove showWarning onRemove={onRemoveAttachment} />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
});
